import {isProd} from "../config/config";

export const STAGE_STRIPE_SKU = "pk_test_51RGytE4Przofw4HLB85BPUqWywcBsclLoVFEkW3tAhtQODe5U0R4bK3aL98S7l34kBC5OWXUhA24qejDeCg9wUIV00XFkWoZih";
export const PROD_STRIPE_SKU = "pk_live_51RGyt7GOgK9toFpPg0Pjs0J6bZjBRNfPciIkwG8t7upXj8EKWITPSu9AoWYn6CmOfthl9OpLT7L0fTPEaZY9puJG00H20ZBiJt";
export const PAYMENT_TYPE_STRIPE = 5;
export const PAYMENT_TYPE_PAYPAL = 6;
export const CURRENCY_COUNTRY_MAP = {
    US: "usd",
    CA: "cad",
    AU: "aud",
};
export const FALL_BACK_CURRENCY = "usd";

export const FALL_BACK_COUNTRY_CODE= "US";

export const getStripeSku = () => {
    return isProd() ? PROD_STRIPE_SKU : STAGE_STRIPE_SKU;
};